import { render } from "./assign-inspector-modal.vue?vue&type=template&id=2c35ce90"
import script from "./assign-inspector-modal.vue?vue&type=script&lang=js"
export * from "./assign-inspector-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__